__turbopack_context__.v({
  "align-center": "Logo-module-scss-module__23_uaW__align-center",
  "align-end": "Logo-module-scss-module__23_uaW__align-end",
  "align-start": "Logo-module-scss-module__23_uaW__align-start",
  "fade-in": "Logo-module-scss-module__23_uaW__fade-in",
  "logo": "Logo-module-scss-module__23_uaW__logo",
  "logo-lg": "Logo-module-scss-module__23_uaW__logo-lg",
  "logo-md": "Logo-module-scss-module__23_uaW__logo-md",
  "logo-sm": "Logo-module-scss-module__23_uaW__logo-sm",
  "no-transform": "Logo-module-scss-module__23_uaW__no-transform",
  "rotate": "Logo-module-scss-module__23_uaW__rotate",
});
